import React, { memo, useEffect, useMemo, useState } from "react";
import { Col, Row, Card, Button, Flex, Progress, Tag, Select, Space } from "antd";
import { getImageURL } from "../util/images";
import { useDispatch, useSelector } from "react-redux";
import CourseService from "../util/course";
import useAuth from "../hooks/useAuth";
import { fetchCoursesAsync } from "../features/courses/coursesSlice";
import { useNavigate } from "react-router-dom";
import Search from "antd/es/input/Search";
import { doArraysOverlap } from "../util/array";
import { selectOrganisation } from "../features/organisations/organisationsSlice";

const CourseItem = memo(({ item }) => {
  const navigate = useNavigate();
  const onCourseClick = () => {
    navigate(`/courses/${item.id}`);
  };
  return (
    <Col key={item.attributes.course.data.id} md={8}>
      <Card
        bordered={false}
        className="CardItem"
        cover={<img alt="" src={getImageURL(item.attributes.course.data.attributes?.Cover?.data?.attributes.url)} />}
        onClick={onCourseClick}
      >
        <h3>{item.attributes.course.data.attributes.Title}</h3>
        <p>{item.attributes.course.data.attributes.Summary}</p>
        <div className="CardTags">
          {item.attributes.course.data.attributes.categories.data?.map((category) => (
            <Tag key={category.attributes.id}>{category.attributes.name}</Tag>
          ))}
        </div>
        <Flex justify="space-between" gap={25}>
          {item.attributes.isCompleted && !item.attributes.started ? (
            <div className={`CardProgress completed`}>
              <Progress percent={100} />
            </div>
          ) : null}
          {item.attributes.started && (
            <div className={`CardProgress ${CourseService.calculateProgress(item) === "100" ? "completed" : "null"}`}>
              <Progress percent={CourseService.calculateProgress(item)} />
            </div>
          )}
          <Button>{item.attributes.started ? "View Course" : "Start Course"}</Button>
        </Flex>
      </Card>
    </Col>
  );
});

export default function CourseItems() {
  const [courses, setCourses] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchKey, setSearchkey] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const organisationData = useSelector(selectOrganisation);
  const showCourses = organisationData?.attributes?.LMS?.show_courses;
  const { auth } = useAuth();
  const dispatch = useDispatch();

  const data = useSelector((state) => state.courses.courses);
  const status = useSelector((state) => state.courses.status);
  const error = useSelector((state) => state.courses.error);

  useEffect(() => {
    if (status === "idle" || (status === "fulfilled" && data === null)) {
      dispatch(fetchCoursesAsync(auth.getUser().id));
    }
  }, [auth, data, dispatch, status]);

  useEffect(() => {
    const getCategories = (item) => {
      return item.categories.data?.map((category) => category.attributes.name).join(", ");
    };

    const getCourses = () => {
      if (searchKey === "" && selectedCategories?.length === 0 && statusFilter === "all") return data;

      return data.filter((item) => {
        const itemStatus = CourseService.calculateProgress(item);
        const itemCategory = getCategories(item.attributes.course.data.attributes).toLowerCase();
        return (
          (searchKey?.length > 0 &&
            (item.attributes.course.data.attributes.Title.toLowerCase().includes(searchKey.toLowerCase()) ||
              itemCategory.includes(searchKey.toLowerCase()))) ||
          doArraysOverlap(selectedCategories, itemCategory.split(", ")) ||
          (statusFilter === "new" && itemStatus == 0) ||
          (statusFilter === "in-progress" && itemStatus > 0 && itemStatus < 100) ||
          (statusFilter === "completed" && itemStatus == 100)
        );
      });
    };

    let courses = getCourses();
    console.log('>>>> courses', courses)
    let sortedCourses = [...courses ?? []]?.sort((a, b) => {
      if (a.attributes.course.data.attributes.Title < b.attributes.course.data.attributes.Title) {
        return -1;
      }
      if (a.attributes.course.data.attributes.Title > b.attributes.course.data.attributes.Title) {
        return 1;
      }
      return 0;
    });
    console.log('>>>> sortedCourses', sortedCourses)
    setCourses(sortedCourses);
  }, [statusFilter, searchKey, selectedCategories, data]);

  const getAllCategories = useMemo(() => {
    if (!data) return [];
    const categories = data
      ?.map((item) => item.attributes.course.data.attributes.categories.data)
      .flat()
      ?.map((category) => category.attributes.name);

    return [...new Set(categories)];
  }, [data]);
  
  console.log('>>>> showCourses', showCourses)
  if (!showCourses) return null;
  if (status === "pending" || data === null) return <div className="AlertInfo Loading">Loading...</div>;
  if (error) return <p>Error :(</p>;

  if (data?.length === 0) return <div className="AlertInfo">No courses found</div>;

  return (
    <div>
      <div className="SearchWrap">
        <Search
          size="large"
          placeholder="Search courses"
          allowClear
          onChange={(event) => setSearchkey(event.target.value)}
          enterButton
          value={searchKey}
        />
        <Select value={statusFilter} onChange={setStatusFilter}>
          <Select.Option value="all">Show All</Select.Option>
          <Select.Option value="new">New</Select.Option>
          <Select.Option value="in-progress">In Progress</Select.Option>
          <Select.Option value="completed">Completed</Select.Option>
        </Select>
      </div>
      <Flex wrap="wrap" style={{ marginTop: "30px" }} className="FilterTags">
        {getAllCategories?.map((category) => (
          <Tag
            color="default"
            key={category}
            className={selectedCategories.includes(category.toLowerCase()) ? "Active" : null}
            onClick={() => {
              if (selectedCategories.includes(category.toLowerCase())) {
                setSelectedCategories(selectedCategories.filter((item) => item !== category.toLowerCase()));
              } else {
                setSelectedCategories([...selectedCategories, category.toLowerCase()]);
              }
            }}
          >
            {category}
          </Tag>
        ))}
      </Flex>
      <Row gutter={[20, 20]} style={{ marginTop: "30px" }}>
        {console.log('>>>> coursesasdad', courses)}
        {courses?.map((item) => (
          <CourseItem key={item.attributes.course.data.id} item={item} />
        ))}
        {courses?.length === 0 && <div className="AlertInfo">No courses found</div>}
      </Row>
    </div>
  );
}
